import { render, staticRenderFns } from "./SocialFooter.vue?vue&type=template&id=91c5d926&"
import script from "./SocialFooter.vue?vue&type=script&lang=js&"
export * from "./SocialFooter.vue?vue&type=script&lang=js&"
import style0 from "./SocialFooter.vue?vue&type=style&index=0&id=91c5d926&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports